"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STUDENT_SPECIALITIES = exports.HEALTHCARE_PROVIDER_SPECIALITIES = exports.ENTHUSIAST_SPECIALITIES = exports.ALTERNATIVE_PRACTITIONER_SPECIALITIES = exports.ACADEMIC_SPECIALITIES = void 0;
const Speciality_1 = require("./Speciality");
exports.ACADEMIC_SPECIALITIES = [
    Speciality_1.Speciality.Anatomy,
    Speciality_1.Speciality.GeneralMedicine,
    Speciality_1.Speciality.Physiology,
    Speciality_1.Speciality.Other,
];
exports.ALTERNATIVE_PRACTITIONER_SPECIALITIES = [
    Speciality_1.Speciality.Chiropractor,
    Speciality_1.Speciality.Homeopathy,
    Speciality_1.Speciality.Acupuncture,
    Speciality_1.Speciality.MassageTherapy,
    Speciality_1.Speciality.Other,
];
exports.ENTHUSIAST_SPECIALITIES = [
    Speciality_1.Speciality.DrawingAnatomy,
    Speciality_1.Speciality.Fitness,
    Speciality_1.Speciality.SelfEducation,
    Speciality_1.Speciality.Other,
];
exports.HEALTHCARE_PROVIDER_SPECIALITIES = [
    Speciality_1.Speciality.GeneralPractitioner,
    Speciality_1.Speciality.Surgery,
    Speciality_1.Speciality.Dentistry,
    Speciality_1.Speciality.Physiotherapy,
    Speciality_1.Speciality.InternalMedicine,
    Speciality_1.Speciality.Nursing,
    Speciality_1.Speciality.SportsMedicine,
    Speciality_1.Speciality.EmergencyMedicine,
    Speciality_1.Speciality.Osteopathy,
    Speciality_1.Speciality.Anesthesiology,
    Speciality_1.Speciality.Radiology,
    Speciality_1.Speciality.Orthopedics,
    Speciality_1.Speciality.OccupationalTherapy,
    Speciality_1.Speciality.Other,
];
exports.STUDENT_SPECIALITIES = [
    Speciality_1.Speciality.Medicine,
    Speciality_1.Speciality.Physiotherapy,
    Speciality_1.Speciality.Nursing,
    Speciality_1.Speciality.Dentistry,
    Speciality_1.Speciality.Optometry,
    Speciality_1.Speciality.SportsMedicine,
    Speciality_1.Speciality.AlternativeMedicine,
    Speciality_1.Speciality.Other,
];
